module.exports = __webpack_public_path__ + "img/usergroup-delete.73a3367a.svg";